import React from 'react';
import PropTypes from 'prop-types';

import Address from '@common/components/address';

const AddressCell = props => (
  <div className="rt-td--default">
    <Address address={props.value} includeValues={props.includeValues} subtext />
  </div>
);

AddressCell.propTypes = {
  includeValues: PropTypes.arrayOf(PropTypes.string),
  value: PropTypes.shape({}),
};

export const makeAddressCell = newProps => props => <AddressCell {...props} {...newProps} />;

export default AddressCell;
